<template>
  <c-input v-model="mobile" v-bind="$attrs" />
</template>

<script>
import {mobileDenormalize, mobileNormalize} from '@/lib/utils'
export default {
  name: 'MobileInput',
  inheritAttrs: false,
  props: {
    value: {type: String, default: null}
  },
  data() {
    return {
      mobile: null
    }
  },
  watch: {
    value: {
      handler(value) {
        this.mobile = mobileDenormalize(value)
      },
      immediate: true
    },
    mobile(value) {
      this.$emit('input', mobileNormalize(value))
    }
  }
}
</script>
